import React, { useState } from "react";
import { userStore } from "../../gStore/user.store";
import { DefaultLayout } from "../../layouts/DefaultLayout";
import { feedbackService } from "../../services/feedback.service";

function UncontrolledForm() {
  const [errors, setErrors] = useState(false);
  const siteName = process.env.REACT_APP_SITENAME || '';

  const handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    const formData = e.target as typeof e.target & {
      age: { dataset: { question: string, type: string }, value: string };
      gender: { dataset: { question: string, type: string }, value: string };
      frequency: { dataset: { question: string, type: string }, value: string };
      favoriteCategory: { dataset: { question: string, type: string }, value: string };
      leastFavoriteCategory: { dataset: { question: string, type: string }, value: string };
      gameDifficulty: { dataset: { question: string, type: string }, value: string };
      controls: { dataset: { question: string, type: string }, value: string };
      navigation: { dataset: { question: string, type: string }, value: string };
      loadTimes: { dataset: { question: string, type: string }, value: string };
      crashing: { dataset: { question: string, type: string }, value: string };
      websiteDesign: { dataset: { question: string, type: string }, value: string };
      leaderboards: { dataset: { question: string, type: string }, value: string };
      recommend: { dataset: { question: string, type: string }, value: string };
      overall: { dataset: { question: string, type: string }, value: string };
      additionalGames: any[];
      comments: { dataset: { question: string, type: string }, value: string };
    };

    type FormResponse = {
      question: string;
      response: string | boolean | number | string[] | null;
      type: string;
    };

    
    //const formData = new FormData(e.target);

    if (formData) {
      
      let validationErrors = false;

      const formattedData: FormResponse[] = []
      formattedData.push ({
        question: formData.age.dataset.question,
        response: formData.age.value || '',
        type: formData.age.dataset.type
      });
      formattedData.push({
        question: formData.gender.dataset.question,
        response: formData.gender.value || '',
        type: formData.gender.dataset.type
      });
      formattedData.push({
        question: formData.frequency.dataset.question,
        response: formData.frequency.value || '',
        type: formData.frequency.dataset.type
      });
      formattedData.push({
        question: formData.favoriteCategory.dataset.question,
        response: formData.favoriteCategory.value || '',
        type: formData.favoriteCategory.dataset.type
      });
      formattedData.push({
        question: formData.leastFavoriteCategory.dataset.question,
        response: formData.leastFavoriteCategory.value || '',
        type: formData.leastFavoriteCategory.dataset.type
      });
      formattedData.push({
        question: formData.gameDifficulty.dataset.question,
        response: formData.gameDifficulty.value || '',
        type: formData.gameDifficulty.dataset.type
      });
      formattedData.push({
        question: formData.controls.dataset.question,
        response: formData.controls.value || '',
        type: formData.controls.dataset.type
      });
      formattedData.push({
        question: formData.navigation.dataset.question,
        response: formData.navigation.value || '',
        type: formData.navigation.dataset.type
      });
      formattedData.push({
        question: formData.loadTimes.dataset.question,
        response: formData.loadTimes.value || '',
        type: formData.loadTimes.dataset.type
      });
      formattedData.push({
        question: "Have you Experienced This App Crashing?",
        response: formData.crashing.value,
        type: 'yesno'
      });
      formattedData.push({
        question: formData.websiteDesign.dataset.question,
        response: formData.websiteDesign.value || '',
        type: formData.websiteDesign.dataset.type
      });
      formattedData.push({
        question: formData.leaderboards.dataset.question,
        response: formData.leaderboards.value || '',
        type: formData.leaderboards.dataset.type
      });
      formattedData.push({
        question: "Likelihood to Recommend App",
        response: !isNaN(parseInt(formData.recommend.value)) ? formData.recommend.value : '',
        type: 'rating'
      });
      formattedData.push({
        question: formData.overall.dataset.question,
        response: formData.overall.value || '',
        type: formData.overall.dataset.type
      });
      let checkedGames: any = [];
      formData.additionalGames.forEach((item: any) => {
        if (item.checked) {
          checkedGames.push(item.value)
        }
      })
      formattedData.push({
        question: "What game categories should we add more games for?",
        response: checkedGames.toString() || '',
        type: 'multiselect'
      });
      formattedData.push({
        question: formData.comments.dataset.question,
        response: formData.comments.value || '',
        type: formData.comments.dataset.type
      });

      let foundValue = false;

      Object.entries(formattedData).forEach((key, value) => {
        if((typeof key[1].response === 'string' && key[1].response !== '') || (typeof key[1].response === 'boolean' && key[1].response) || (typeof key[1].response === 'number' && key[1].response > 0) || (typeof key[1].response === 'object' && Array.isArray(key[1].response) && key[1].response.length > 0 )) {
          foundValue = true;
        }
      })

      if (!foundValue) {
        validationErrors = true;
      }

      if (validationErrors) {
        setErrors(true);
      } else {
        try {
          feedbackService.sendFeedback({
            formName: 'Games General Feedback',
            form: formattedData
          })
        } catch (err) {
          console.log(err)
        }
        // Handle the successful form submission, e.g., sending formData to a server
        setErrors(false); // Clear any previous errors
      }
    }
  };

  return (
    <DefaultLayout title="Feedback">
      <section className='py-8'>
        <div className="container">
          <form onSubmit={handleSubmit} id="feedbackForm" className="w-full max-w-sm ml-auto mr-auto">
            {errors && <div className="error">At least one field needs to be filled out to submit the form.</div>}

            <input type="hidden" name="userId" value={userStore.data.user.id} />

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Age:</label>
                <select id="age" name="age" data-question="Age" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select an Age Range</option>
                  <option value="18-24">18-24</option>
                  <option value="25-34">25-34</option>
                  <option value="35-44">35-44</option>
                  <option value="45-54">45-54</option>
                  <option value="55-64">55-64</option>
                  <option value="65+">65+</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Gender:</label>
                <select id="gender" name="gender" data-question="Gender" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Gender</option>
                  <option value="male">Male</option>
                  <option value="female">Female</option>
                  <option value="other">Other</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">How Often Do You Play {siteName}?</label>
                <select id="frequency" name="frequency" data-question={`How Often Do You Play ${siteName}?`} data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Frequency</option>
                  <option value="daily">Daily</option>
                  <option value="weekly">Weekly</option>
                  <option value="monthly">Monthly</option>
                  <option value="rarely">Rarely</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Favorite Game Category:</label>
                <select id="favoriteCategory" name="favoriteCategory" data-question="Favorite Game Category" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Game Category</option>
                  <option value="idle">Idle</option>
                  <option value="strategy">Strategy</option>
                  <option value="action">Action</option>
                  <option value="puzzle">Puzzle</option>
                  <option value="educational">Educational</option>
                  <option value="sport">Sport</option>
                  <option value="card">Card</option>
                  <option value="racing">Racing</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Least Favorite Game Category:</label>
                <select id="leastFavoriteCategory" name="leastFavoriteCategory" data-question="Least Favorite Game Gategory" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Game Category</option>
                  <option value="idle">Idle</option>
                  <option value="strategy">Strategy</option>
                  <option value="action">Action</option>
                  <option value="puzzle">Puzzle</option>
                  <option value="educational">Educational</option>
                  <option value="sport">Sport</option>
                  <option value="card">Card</option>
                  <option value="racing">Racing</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Game Difficulty:</label>
                <select id="gameDifficulty" name="gameDifficulty" data-question="Game Difficulty" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Difficulty</option>
                  <option value="easy">Too easy</option>
                  <option value="right">Just right</option>
                  <option value="hard">Too hard</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">What game categories should we add more games for?</label>
                <input type="checkbox" id="additionalGames-idle" name="additionalGames" value="idle" className="mr-2 leading-tight"/>
                <label htmlFor="additionalGames-idle"> Idle</label><br/>
                <input type="checkbox" id="additionalGames-strategy" name="additionalGames" value="strategy" className="mr-2 leading-tight"/>
                <label htmlFor="additionalGames-strategy"> Strategy</label><br/>
                <input type="checkbox" id="additionalGames-action" name="additionalGames" value="action" className="mr-2 leading-tight"/>
                <label htmlFor="additionalGames-action"> Action</label><br/>
                <input type="checkbox" id="additionalGames-puzzle" name="additionalGames" value="puzzle" className="mr-2 leading-tight"/>
                <label htmlFor="additionalGames-puzzle"> Puzzle</label><br/>
                <input type="checkbox" id="additionalGames-educational" name="additionalGames" value="educational" className="mr-2 leading-tight"/>
                <label htmlFor="additionalGames-educational"> Educational</label><br/>
                <input type="checkbox" id="additionalGames-sport" name="additionalGames" value="sport" className="mr-2 leading-tight"/>
                <label htmlFor="additionalGames-sport"> Sport</label><br/>
                <input type="checkbox" id="additionalGames-card" name="additionalGames" value="card" className="mr-2 leading-tight"/>
                <label htmlFor="additionalGames-card"> Card</label><br/>
                <input type="checkbox" id="additionalGames-racing" name="additionalGames" value="racing" className="mr-2 leading-tight"/>
                <label htmlFor="additionalGames-racing"> Racing</label><br/>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Overall Product Design:</label>
                <select id="websiteDesign" name="websiteDesign" data-question="Overall Product Design" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Response</option>
                  <option value="love">Love it</option>
                  <option value="like">Like it</option>
                  <option value="okay">It's okay</option>
                  <option value="dont-like">Don't like it</option>
                  <option value="hate">Hate it</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Controls and Interface:</label>
                <select id="controls" name="controls" data-question="Controls and Interface" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Response</option>
                  <option value="very-easy">Very easy</option>
                  <option value="easy">Easy</option>
                  <option value="neutral">Neutral</option>
                  <option value="difficult">Difficult</option>
                  <option value="very-difficult">Very difficult</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Ease of Navigation:</label>
                <select id="navigation" name="navigation" data-question="Ease of Navigation" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Response</option>
                  <option value="very-easy">Very easy</option>
                  <option value="easy">Easy</option>
                  <option value="neutral">Neutral</option>
                  <option value="difficult">Difficult</option>
                  <option value="very-difficult">Very difficult</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Load Times and Performance:</label>
                <select id="loadTimes" name="loadTimes" data-question="Load Times and Performance" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Response</option>
                  <option value="excellent">Excellent</option>
                  <option value="good">Good</option>
                  <option value="average">Average</option>
                  <option value="poor">Poor</option>
                  <option value="very-poor">Very poor</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Leaderboards Engagement:</label>
                <select id="leaderboards" name="leaderboards" data-question="Leaderboards Engagement" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Response</option>
                  <option value="very-engaging">Very engaging</option>
                  <option value="engaging">Engaging</option>
                  <option value="neutral">Neutral</option>
                  <option value="not-engaging">Not engaging</option>
                  <option value="dont-use">Don't use it</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>
            
            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Have you Experienced This App Crashing?</label>
                <input type="radio" id="crashing-yes" name="crashing" value="yes" data-question="Have you Experienced This App Crashing?" data-type="truefalse" className="mr-2 leading-tight"/>
                <label htmlFor="crashing-yes">Yes</label><br/>
                <input type="radio" id="crashing-no" name="crashing" value="no" data-question="Have you Experienced This App Crashing?" data-type="truefalse" className="mr-2 leading-tight"/>
                <label htmlFor="crashing-no">No</label><br/>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Likelihood to Recommend App:</label>
              <div className="grid grid-cols-10  items-center align-center">
                <input type="radio" id="recommend-1" name="recommend" value="1" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-2" name="recommend" value="2" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-3" name="recommend" value="3" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-4" name="recommend" value="4" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-5" name="recommend" value="5" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-6" name="recommend" value="6" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-7" name="recommend" value="7" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-8" name="recommend" value="8" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-9" name="recommend" value="9" data-question="Likelihood to Recommend App" data-type="freeform"/>
                <input type="radio" id="recommend-10" name="recommend" value="10" data-question="Likelihood to Recommend App" data-type="freeform"/>
              </div>
              <div className="grid grid-cols-10 items-start text-center mb-6 align-top">
                <label htmlFor="crashing-1s">1<br/>(Not likely)</label>
                <label htmlFor="recommend-2">2</label>
                <label htmlFor="recommend-3">3</label>
                <label htmlFor="recommend-4">4</label>
                <label htmlFor="recommend-5">5</label>
                <label htmlFor="recommend-6">6</label>
                <label htmlFor="recommend-7">7</label>
                <label htmlFor="recommend-8">8</label>
                <label htmlFor="recommend-9">9</label>
                <label htmlFor="recommend-10">10<br/>(Very likely)</label>
              </div>
            </div>

            <div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Overall Rating:</label>
                <select id="overall" name="overall" data-question="Overall Rating" data-type="dropdown" className="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline text-gray-500">
                  <option value="">Select a Response</option>
                  <option value="excellent">Excellent</option>
                  <option value="good">Good</option>
                  <option value="average">Average</option>
                  <option value="poor">Poor</option>
                  <option value="very-poor">Very Poor</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 top-[28px] flex items-center px-2 text-gray-700">
                  <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                </div>
              </div>
            </div>

            {/*<div className="md:flex md:items-center mb-6">
              <div className="md:w-1/3 relative">
                <label className="block text-gray-500 font-bold md:text-right mb-1 md:mb-0 pr-4">Additional Comments:</label>
                <textarea id="comments" name="comments" rows={4} cols={50} form="feedbackForm" data-question="Additional Comments" data-type="freeform" className="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500 block p-2.5 w-full text-sm border" placeholder="Leave a comment..."></textarea>
              </div>
            </div>*/}
            <div className="md:flex md:items-center">
              <div className="md:w-1/3"></div>
              <div className="md:w-2/3">
                <button className="shadow bg-purple-500 hover:bg-purple-400 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded" type="submit">
                  Submit Form
                </button>
              </div>
            </div>
          </form>
        </div>
      </section>
    </DefaultLayout>
  );
}

export default UncontrolledForm;
